import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Button,
  Popover,
  SpaceBetween,
  Box,
} from "@amzn/awsui-components-react";
import { IItemNavigatorProps, navStore } from "./definitions";
import styles from "./style.module.scss";

const ItemNavigator: React.FC<IItemNavigatorProps> = ({
  currentId,
  buildPath,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const navKey: string | undefined = (location.state as any)?.navKey;

  if (!navKey || !currentId) return null;

  const navItems = navStore.get(navKey);
  if (!navItems) return null;

  const currentIndex = navItems.findIndex((item) => item.id === currentId);
  if (currentIndex === -1) return null;

  const goTo = (index: number) => {
    navigate(buildPath(navItems[index].id), {
      replace: true,
      state: { navKey },
    });
  };

  const prevItem = currentIndex > 0 ? navItems[currentIndex - 1] : null;
  const nextItem =
    currentIndex < navItems.length - 1 ? navItems[currentIndex + 1] : null;

  return (
    <div className={styles.itemNavigator} data-testid="item-navigator">
      <SpaceBetween direction="horizontal" size="xxs" alignItems="center">
        {prevItem ? (
          <Popover
            dismissButton={false}
            position="bottom"
            size="large"
            triggerType="custom"
            content={<Box>Previous: {prevItem.label}</Box>}
          >
            <Button
              iconName="angle-left"
              variant="icon"
              onClick={() => goTo(currentIndex - 1)}
              ariaLabel={`Previous: ${prevItem.label}`}
            />
          </Popover>
        ) : (
          <Button
            iconName="angle-left"
            variant="icon"
            disabled
            ariaLabel="No previous item"
          />
        )}
        <span style={{ whiteSpace: "nowrap", fontSize: "14px" }}>
          {currentIndex + 1} of {navItems.length}
        </span>
        {nextItem ? (
          <Popover
            dismissButton={false}
            position="bottom"
            size="large"
            triggerType="custom"
            content={<Box>Next: {nextItem.label}</Box>}
          >
            <Button
              iconName="angle-right"
              variant="icon"
              onClick={() => goTo(currentIndex + 1)}
              ariaLabel={`Next: ${nextItem.label}`}
            />
          </Popover>
        ) : (
          <Button
            iconName="angle-right"
            variant="icon"
            disabled
            ariaLabel="No next item"
          />
        )}
      </SpaceBetween>
    </div>
  );
};

export default ItemNavigator;
